export enum VehicleLock {
    OUT1 = 'OUT1',
    OUT2 = 'OUT2',
}

export enum VehicleHistoryLockType {
    FailedToTurnOn = 0,
    SuccessToTurnOn = 1,
    FailedToTurnOff = 2,
    SuccessToTurnOff = 3,
}

export enum VehicleBlockerValue {
    Unknown = 0, // ten nie powinien być nigdy zwrócony, jeżeli jakoś się pojawi to znaczy że pojazd nie ma blokady
    Off = 1,  // blokada wyłączona
    On = 2, // blokada włączona
    ChangePending = 3,
}

export interface ISetLockVehicleState {
    VehicleId: number;
    OutName: VehicleLock;
    Value: boolean;
}

export interface IGetLockVehicleState {
    VehicleId: number;
    BlockerInfos: IBlockerInfo[];
}

export interface IBlockerInfo {
    BlockerValue: VehicleBlockerValue;
    OutName: string;
    ParameterId: number;
    VehicleId: number;
}

export interface IVehicleHistoryResponse {
    Entries: IVehicleHistoryLock[];
}

export interface IVehicleHistoryLock {
    Description: string;
    Timestamp: string;
    UserName: string;
    VehicleId: number;
    EntryType: VehicleHistoryLockType;
    OutName: string;
}
